import type { MailboxInfo } from 'owa-client-types';
import { isSharedCoprincipalAccountEnabled } from './isSharedCoprincipalAccountEnabled';
import { isMailboxSharedOrDelegateUserMailbox } from './isMailboxSharedOrDelegateUserMailbox';
import { isAccountExplicitLogon } from './isAccountExplicitLogon';
import { isMailboxSharedResourceArchive } from './isMailboxSharedArchive';

/**
 * Returns true if the mailbox is shared or a delegate mailbox either the main user mailbox
 * of the account or an other mailbox in the account.
 */
export function isMailboxSharedOrDelegate(mailboxInfo: MailboxInfo): boolean {
    if (mailboxInfo.type === 'UserMailbox') {
        return isSharedCoprincipalAccountEnabled()
            ? isMailboxSharedOrDelegateUserMailbox(mailboxInfo)
            : isAccountExplicitLogon(mailboxInfo);
    }

    if (mailboxInfo.type === 'ArchiveMailbox') {
        return isAccountExplicitLogon(mailboxInfo) || isMailboxSharedResourceArchive(mailboxInfo);
    }

    return mailboxInfo.type === 'SharedMailbox';
}
